import { Controller } from '@hotwired/stimulus';
import { Offcanvas } from 'bootstrap';
import { showToast } from '../lib/toastr';

// Manages the Lemonway CB payment slide-over with an embedded iframe.
// Listens for postMessage from the iframe callback to detect
// payment success/failure, then redirects accordingly.
//
// Actions (declared in the template):
//   message@window->lemonway-payment#handleMessage
//   load->lemonway-payment#iframeLoaded (on iframe target)
export default class LemonwayPaymentController extends Controller {
  static targets = ['iframe', 'loader'];
  static values = {
    iframeUrl: String,
    redirectUrl: String,
    successMessage: String,
    errorMessage: String,
    slideOverId: String,
  };

  connect() {
    this.slideOverEl = document.getElementById(this.slideOverIdValue);
    this.offcanvas = new Offcanvas(this.slideOverEl);
    this.boundCleanup = () => this.element.remove();
    this.slideOverEl.addEventListener('hidden.bs.offcanvas', this.boundCleanup);
    this.offcanvas.show();
  }

  disconnect() {
    if (this.slideOverEl) {
      this.slideOverEl.removeEventListener('hidden.bs.offcanvas', this.boundCleanup);
    }
    if (this.offcanvas) {
      this.offcanvas.dispose();
    }
  }

  teardown() {
    this.element.remove();
  }

  iframeLoaded() {
    this.loaderTarget.classList.add('d-none');
    this.iframeTarget.classList.remove('d-none');
  }

  handleMessage(event) {
    if (event.origin !== window.location.origin) return;
    if (!event.data || event.data.type !== 'lemonway-payment-callback') {
      return;
    }

    const { status } = event.data;

    this.offcanvas.hide();

    const message = status === 'success'
      ? this.successMessageValue
      : this.errorMessageValue;
    const type = status === 'success' ? 'success' : 'error';

    document.addEventListener('turbo:load', () => {
      showToast(type, message);
    }, { once: true });

    window.Turbo.visit(this.redirectUrlValue);
  }
}
